"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _SendAddressComponent = _interopRequireDefault(require("./SendAddressComponent"));
var _withdrawActions = require("../../../redux/actions/withdrawActions");
var _config = _interopRequireDefault(require("../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    withdrawInfo: state.withdraw,
    WalletsDisabledMessage: _config["default"].global.WalletsDisabledMessage
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    selectWithdrawProduct: function selectWithdrawProduct(productId) {
      return dispatch((0, _withdrawActions.fetchProductWithdrawTemplates)(productId));
    },
    selectWithdrawTemplate: function selectWithdrawTemplate(ProductId, AccountProviderId) {
      return dispatch((0, _withdrawActions.fetchProductWithdrawTemplate)(ProductId, AccountProviderId));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SendAddressComponent["default"]);